// Printed field timesheet (customer T&M sheet) — shared by Field Tracker and the Customer Portal.
/* eslint-disable */
export function printTimesheet(data, dateFrom, dateTo, signatureDataUrl, numbersByWo, winParam) {
  var pw = winParam || window.open('', '_blank');
  if (!pw) return;
  var LETTERHEAD = window.location.origin + '/365isi-letterhead.jpg';
  var weDate = new Date(dateTo + 'T00:00:00').toLocaleDateString('en-US', {month:'2-digit',day:'2-digit',year:'numeric'});
  var regDates = (data.dates || []).filter(function(d) { var dow = new Date(d+'T00:00:00').getDay(); return dow >= 1 && dow <= 5; });
  var allDates = data.dates || [];
  var isWeekday = function(d) { var dow = new Date(d+'T00:00:00').getDay(); return dow >= 1 && dow <= 5; };
  var fmtH = function(x) { return x ? (Math.round(x * 100) / 100) : ''; };
  // Office-editable billing extras (Field Tracker → Pay Rates). Saved timesheets carry the rates they were printed with.
  var billing = data.billing_rates || {};
  var TRUCK_RATE = billing.truck_rate != null ? Number(billing.truck_rate) : 155;
  var TRAVEL_RATE = billing.travel_rate != null ? Number(billing.travel_rate) : 65.00;
  var AFT_PREMIUM = billing.afternoon_premium != null ? Number(billing.afternoon_premium) : 2.00;

  data.work_orders.forEach(function(wo, woIdx) {
    var rates = data.labour_rates || {};
    var mwRate = rates.MW ? rates.MW.regular : 84.00;
    var mwfRate = rates.MWF ? rates.MWF.regular : 86.00;
    var mwOtRate = rates.MW ? rates.MW.overtime : 126.00;
    var mwfOtRate = rates.MWF ? rates.MWF.overtime : 129.00;
    // Double time (stat holiday / breakdown) = 2× the regular rate unless a 'double' rate is set on the code
    var mwDtRate = (rates.MW && rates.MW.double) ? rates.MW.double : mwRate * 2;
    var mwfDtRate = (rates.MWF && rates.MWF.double) ? rates.MWF.double : mwfRate * 2;
    // Shop fabrication hours on this job (FAB rows from the Shop Tracker) bill at the FAB rate card —
    // never MW/MWOT, and the per-job flat override (field workers) does not touch them.
    var fabRate = rates.FAB ? rates.FAB.regular : 70.00;
    var fabOtRate = rates.FAB ? rates.FAB.overtime : 105.00;
    var fabDtRate = (rates.FAB && rates.FAB.double) ? rates.FAB.double : fabRate * 2;
    var codeOf = function(emp) { return emp.is_fab ? 'FAB' : (emp.is_foreman ? 'MWF' : 'MW'); };
    // Per-job flat rate override: every field worker on this WO bills at one rate, OT = 1.5x, DT = 2x.
    if (wo.rate_override != null && wo.rate_override > 0) {
      mwRate = mwfRate = wo.rate_override;
      mwOtRate = mwfOtRate = wo.rate_override * 1.5;
      mwDtRate = mwfDtRate = wo.rate_override * 2;
    }
    var tsNum = (numbersByWo && numbersByWo[wo.work_order_number]) || wo.work_order_number;
    var custName = wo.customer_name ? wo.customer_name : '____________________';
    var jobDesc = wo.description ? wo.description : '';
    var billingLabel = wo.billing_type === 'tm' ? 'T&amp;M' : (wo.billing_type === 'costing' ? 'COSTING' : '');
    var sigHtml = signatureDataUrl ? '<img src="' + signatureDataUrl + '" style="height:35px"/>' : '';

    // ----- Tally regular/overtime by labour code (MWF foreman vs MW millwright) -----
    // Per-day OT mode override (from Field Crew approval): all_ot / all_reg / all_dt beat the
    // default weekday-8h-cap rule. Afternoon-shift hours bill at the rate + $2/hr premium
    // (so OT on afternoons = (rate + 2) x 1.5, not a flat $2 line) — tallied in their own buckets.
    var newBucket = function() { return { reg: 0, ot: 0, dt: 0, aftReg: 0, aftOt: 0, aftDt: 0 }; };
    var tally = { MWF: newBucket(), MW: newBucket(), FAB: newBucket() };
    var travelHrs = 0, travelAmt = 0;
    var dtReasons = {};  // date -> reason, for the footnote under the grid
    var weekendReg = false;  // any regular-time hours on a Sat/Sun (make-up day) -> 'R' footnote
    var bandHrs = (wo.travel && wo.travel.band_hours) || 0;
    wo.employees.forEach(function(emp) {
      var b = tally[codeOf(emp)];
      var otModes = emp.ot_by_day || {};
      var aftDays = emp.afternoon_by_day || {};
      var splits = emp.reg_ot_by_day || {};
      var travelDays = emp.travel_by_day || {};
      var reasons = emp.dt_reason_by_day || {};
      allDates.forEach(function(d) {
        // Day-level travel hours (away jobs) bill at the travel rate — pulled out before the reg/OT split
        var trav = Math.min(Number(travelDays[d] || 0), emp.hours_by_day[d] || 0);
        if (trav > 0) { travelHrs += trav; travelAmt += trav * TRAVEL_RATE; }
        var hrs = (emp.hours_by_day[d] || 0) - trav;
        var sp = splits[d];
        var reg = 0, ot = 0, dt = 0;
        if (sp) { reg = sp.reg; ot = sp.ot; dt = sp.dt || 0; }
        else {
          var mode = otModes[d];
          if (mode === 'all_dt') { dt = hrs; }
          else if (mode === 'all_ot') { ot = hrs; }
          else if (mode === 'all_reg') { reg = hrs; }
          else if (isWeekday(d)) { reg = Math.min(hrs, 8); ot = Math.max(hrs - 8, 0); }
          else { ot = hrs; }
        }
        if (dt > 0) dtReasons[d] = reasons[d] || dtReasons[d] || 'double_time';
        if (reg > 0 && !isWeekday(d)) weekendReg = true;
        if (aftDays[d]) { b.aftReg += reg; b.aftOt += ot; b.aftDt += dt; }
        else { b.reg += reg; b.ot += ot; b.dt += dt; }
      });
      // Travel: paid per on-site day at a flat $65/hr. Mode: standard = crew 1-way, foremen 2-way;
      // one_way = everyone 1-way; two_way = everyone both ways. Hours/way come from the km band or
      // the manually set hours. Shop (FAB) rows never travel.
      if (bandHrs > 0 && !emp.is_fab) {
        var tMode = (wo.travel && wo.travel.travel_mode) || ((wo.travel && wo.travel.one_way_only) ? 'one_way' : 'standard');
        var ways = tMode === 'two_way' ? 2 : tMode === 'one_way' ? 1 : (emp.is_foreman ? 2 : 1);
        var onDays = allDates.filter(function(d) { return (emp.hours_by_day[d] || 0) > 0; }).length;
        var tHrs = onDays * bandHrs * ways;
        travelHrs += tHrs;
        travelAmt += tHrs * TRAVEL_RATE;
      }
    });
    // Service vehicle: 1 truck per truck-holder (e.g. licensed foreman with a company
    // truck) OR 1 per 4 of the remaining crew — whichever is greater, per on-site day.
    // A per-job override (e.g. foremen carpooling in one truck) wins when set.
    var truckOverride = (wo.truck_override != null && wo.truck_override !== '') ? Number(wo.truck_override) : null;
    var trucksPerDay = [];
    allDates.forEach(function(d) {
      var onSite = wo.employees.filter(function(emp) { return !emp.is_fab && (emp.hours_by_day[d] || 0) > 0; });
      if (onSite.length === 0) return;
      if (truckOverride != null) { trucksPerDay.push(truckOverride); return; }
      var truckHolders = onSite.filter(function(emp) { return emp.has_company_truck; }).length;
      var nonHolders = onSite.length - truckHolders;
      trucksPerDay.push(Math.max(truckHolders, Math.ceil(nonHolders / 4)));
    });
    var onSiteDays = trucksPerDay.length;
    var truckDayUnits = trucksPerDay.reduce(function(s, x) { return s + x; }, 0);
    var truckUniform = onSiteDays > 0 && trucksPerDay.every(function(x) { return x === trucksPerDay[0]; });
    var truckQty = onSiteDays === 0 ? 0 : (truckUniform ? trucksPerDay[0] : Math.max.apply(null, trucksPerDay));
    var truckSubtotal = truckDayUnits * TRUCK_RATE;
    // Rate lines: code / hours / rate — afternoon lines carry the premium baked into the rate
    var rateLines = [];
    var pushLines = function(code, b, regRate, otRate, dtRate, title, always) {
      var otMult = regRate > 0 ? otRate / regRate : 1.5;
      rateLines.push({ code: code, hours: b.reg, rate: regRate, always: always, title: title + ' — regular' });
      rateLines.push({ code: code + 'OT', hours: b.ot, rate: otRate, always: always, title: title + ' — overtime' });
      rateLines.push({ code: code + 'DT', hours: b.dt, rate: dtRate, title: title + ' — double time' });
      rateLines.push({ code: code + '-AFT', hours: b.aftReg, rate: regRate + AFT_PREMIUM, title: title + ' — regular, afternoon shift (+$' + AFT_PREMIUM.toFixed(2) + '/hr)' });
      rateLines.push({ code: code + 'OT-AFT', hours: b.aftOt, rate: otRate + AFT_PREMIUM * otMult, title: title + ' — overtime, afternoon shift ((rate + $' + AFT_PREMIUM.toFixed(2) + ') x ' + otMult.toFixed(1) + ')' });
      rateLines.push({ code: code + 'DT-AFT', hours: b.aftDt, rate: dtRate + AFT_PREMIUM * 2, title: title + ' — double time, afternoon shift' });
    };
    pushLines('MWF', tally.MWF, mwfRate, mwfOtRate, mwfDtRate, 'Foreman', true);
    pushLines('MW', tally.MW, mwRate, mwOtRate, mwDtRate, 'Millwright', true);
    pushLines('FAB', tally.FAB, fabRate, fabOtRate, fabDtRate, 'Fabrication shop', false);
    rateLines.forEach(function(l) { l.amount = l.hours * l.rate; });
    var totalLabour = rateLines.reduce(function(sum, l) { return sum + l.amount; }, 0) + travelAmt;

    var h = '';
    h += '<html><head><title>Timesheet - ' + tsNum + '</title>';
    h += '<style>';
    h += 'body{font-family:Arial,sans-serif;font-size:10px;margin:0;padding:16px 22px;color:#000}';
    h += 'table{border-collapse:collapse}td,th{padding:3px 4px;vertical-align:top;font-size:9px}';
    h += '.bdr td,.bdr th{border:1px solid #888}';
    h += '.blue{background:#4472c4;color:#fff;font-weight:bold;font-size:12px;padding:5px 5px}';
    h += '.grey{background:#dce6f1;font-weight:bold;font-size:9px;text-align:center;padding:4px 3px}';
    h += '.sub{background:#c5d9f1;font-weight:bold;text-align:center}';
    h += '.r{text-align:right}.c{text-align:center}.l{text-align:left}.b{font-weight:bold}';
    h += '.sm{font-size:8.5px}.med{font-size:9px}';
    h += '.sig{border-bottom:1px solid #000;min-width:150px;display:inline-block;height:18px}';
    h += '.grey{white-space:nowrap}';
    // Screen layout = print layout (letter, 0.4cm margins, 18px body padding ≈ 750px wide) so the
    // fit-to-page check below measures real print heights.
    h += '.ts-page{width:750px;margin:0 auto;box-sizing:border-box}';
    h += '.ts-cust{display:flex;align-items:flex-end;gap:12px;font-size:11px;margin-bottom:3px;white-space:nowrap}';
    h += '.ts-cust .grow{flex:1 1 auto;min-width:0;white-space:normal;line-height:1.15}';
    h += '@media print{body{padding:12px 18px}@page{size:portrait;margin:0.4cm}}';
    h += '</style></head><body>';
    // Each work order is a separate job/customer — force it onto its own page.
    h += '<div class="ts-page"' + (woIdx > 0 ? ' style="page-break-before:always"' : '') + '>';

    // ========== HEADER ==========
    h += '<div style="text-align:center;margin-bottom:2px;height:82px"><img src="' + LETTERHEAD + '" style="width:400px;height:82px"/></div>';
    h += '<table style="width:100%;margin-bottom:3px"><tr>';
    h += '<td style="width:55%;vertical-align:top">';
    h += '</td>';
    h += '<td style="width:45%;text-align:right;vertical-align:top;font-size:11px">';
    h += '<b>Timesheet:</b> <span style="font-size:15px;font-weight:bold;color:#c00">' + tsNum + '</span><br/>';
    h += weDate + '<br/>';
    h += '<b>Week Ending:</b> ________<br/>';
    h += '<b>Sub#</b> ___&nbsp;&nbsp;<b>Extra 1</b>';
    h += '</td></tr></table>';

    // ========== CUSTOMER + WO# + BILLING TYPE + JOB SITE ==========
    // WO# / billing / Job site never wrap; a long job description wraps on the left only, and the
    // fit-to-page pass below shrinks the sheet a touch so it still prints on one page.
    h += '<div class="ts-cust">';
    h += '<div class="grow"><b>Customer Name:</b> <span style="font-size:17px;font-weight:bold">' + custName + '</span>'
      + (jobDesc ? ' <span style="font-size:13px;color:#333">&mdash;&nbsp;' + escHtml(jobDesc) + '</span>' : '') + '</div>';
    h += '<div style="flex:none"><b>Work Order #:</b> <span style="font-size:17px;font-weight:bold;font-family:monospace">' + wo.work_order_number + '</span>'
      + (billingLabel ? '&nbsp;&nbsp;&nbsp;<span style="font-weight:bold;font-size:13px;text-decoration:underline">' + billingLabel + '</span>' : '') + '</div>';
    h += '<div style="flex:none;margin-left:auto"><b>Job site:</b> ____________________</div>';
    h += '</div>';
    // Customer PO (column J of the Work Orders sheet — most recent invoice row) so the timesheet matches the invoice
    if (wo.po_number) {
      h += '<div style="font-size:11px;margin:-1px 0 3px 0"><b>Customer PO #:</b> <span style="font-size:14px;font-weight:bold;font-family:monospace;border:1px solid #000;padding:0 6px">' + escHtml(String(wo.po_number)) + '</span></div>';
    }

    // ========== SERVICE DESCRIPTION ==========
    h += '<table class="bdr" style="width:100%;margin-bottom:3px">';
    h += '<tr><td style="font-size:10px;padding:4px 4px"><b>Service covered by this Timesheet:</b></td></tr>';
    var svcText = serviceText(wo);
    if (svcText) {
      h += '<tr><td style="padding:5px 6px;font-size:10.5px;line-height:1.35;white-space:pre-wrap">' + escHtml(svcText) + '</td></tr>';
    } else {
      h += '<tr><td style="min-height:24px;padding:6px 4px;font-size:10px">&nbsp;</td></tr>';
      h += '<tr><td style="min-height:24px;padding:6px 4px;font-size:10px">&nbsp;</td></tr>';
    }
    h += '</table>';

    // ========== LABOUR ==========
    h += '<table class="bdr" style="width:100%;margin-bottom:3px">';
    h += '<tr><td class="blue" colspan="2">Labour</td>';
    h += '<td class="blue c" colspan="' + (regDates.length + 1) + '">Regular Hours</td>';
    h += '<td class="blue c" colspan="' + (allDates.length + 1) + '">Overtime</td></tr>';
    // Day headers
    h += '<tr><td class="grey" style="width:34px">Code</td>';
    h += '<td class="grey l" style="width:140px">Employee Name</td>';
    regDates.forEach(function(d) { var dt = new Date(d+'T00:00:00'); h += '<td class="grey" style="width:16px">' + ['S','M','T','W','T','F','S'][dt.getDay()] + '</td>'; });
    h += '<td class="sub" style="width:40px;font-size:7px">subtotal</td>';
    allDates.forEach(function(d) { var dt = new Date(d+'T00:00:00'); h += '<td class="grey" style="width:14px">' + ['S','M','T','W','T','F','S'][dt.getDay()] + '</td>'; });
    h += '<td class="sub" style="width:40px;font-size:7px">subtotal</td></tr>';

    // Employee data rows — regular hours capped at 8/day, overflow + weekends to overtime
    // (unless the day carries an explicit OT mode from Field Crew approval).
    wo.employees.forEach(function(emp) {
      var regSub = 0, otSub = 0;
      var regByDay = {}, otByDay = {}, dtByDay = {};
      var otModes = emp.ot_by_day || {};
      var rowSplits = emp.reg_ot_by_day || {};
      var rowTravel = emp.travel_by_day || {};
      allDates.forEach(function(d) {
        var hrs = (emp.hours_by_day[d] || 0) - Math.min(Number(rowTravel[d] || 0), emp.hours_by_day[d] || 0);
        var sp = rowSplits[d];
        if (sp) { regByDay[d] = sp.reg; otByDay[d] = sp.ot; dtByDay[d] = sp.dt || 0; }
        else {
          var mode = otModes[d];
          if (mode === 'all_dt') { regByDay[d] = 0; otByDay[d] = 0; dtByDay[d] = hrs; }
          else if (mode === 'all_ot') { regByDay[d] = 0; otByDay[d] = hrs; }
          else if (mode === 'all_reg') { regByDay[d] = hrs; otByDay[d] = 0; }
          else if (isWeekday(d)) { regByDay[d] = Math.min(hrs, 8); otByDay[d] = Math.max(hrs - 8, 0); }
          else { regByDay[d] = 0; otByDay[d] = hrs; }
        }
        regSub += regByDay[d]; otSub += otByDay[d] + (dtByDay[d] || 0);
      });
      var code = codeOf(emp);
      h += '<tr><td class="c b med">' + code + '</td>';
      h += '<td class="med" style="padding-left:2px">' + emp.employee_name + '</td>';
      regDates.forEach(function(d) { h += '<td class="c med">' + fmtH(regByDay[d]) + '</td>'; });
      h += '<td class="sub med">' + fmtH(regSub) + '</td>';
      // Double-time hours sit in the Overtime columns, bold with a ² so the customer can tie them to the DT rate line.
      // Regular-time hours on a weekend (make-up day) have no Regular column — they show here with an R.
      allDates.forEach(function(d) {
        var dt = dtByDay[d] || 0;
        var wkndReg = !isWeekday(d) ? (regByDay[d] || 0) : 0;
        if (dt > 0) h += '<td class="c med b">' + fmtH(dt + (otByDay[d] || 0)) + '<sup>2</sup></td>';
        else if (wkndReg > 0) h += '<td class="c med">' + ((otByDay[d] || 0) > 0 ? fmtH(otByDay[d]) + ' / ' : '') + fmtH(wkndReg) + '<sup>R</sup></td>';
        else h += '<td class="c med">' + fmtH(otByDay[d]) + '</td>';
      });
      h += '<td class="sub med">' + fmtH(otSub) + '</td></tr>';
    });
    // Empty rows to fill to 8
    for (var i = wo.employees.length; i < 8; i++) {
      h += '<tr><td>&nbsp;</td><td></td>';
      for (var j = 0; j < regDates.length; j++) h += '<td></td>';
      h += '<td class="sub"></td>';
      for (var k = 0; k < allDates.length; k++) h += '<td></td>';
      h += '<td class="sub"></td></tr>';
    }
    h += '</table>';
    if (weekendReg) {
      h += '<div style="font-size:8.5px;margin:-2px 0 3px 2px"><b><sup>R</sup> Regular time</b> — weekend hours worked at straight time (make-up day); billed on the regular rate line.</div>';
    }
    var dtDates = Object.keys(dtReasons).sort();
    if (dtDates.length) {
      var reasonLabel = { stat_holiday: 'Stat holiday', breakdown: 'Breakdown', double_time: 'Double time' };
      h += '<div style="font-size:8.5px;margin:-2px 0 3px 2px"><b><sup>2</sup> Double time</b> (2× regular rate): ' + dtDates.map(function(d) {
        var dd = new Date(d + 'T00:00:00');
        return ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'][dd.getDay()] + ' ' + (dd.getMonth() + 1) + '/' + dd.getDate() + ' — ' + (reasonLabel[dtReasons[d]] || 'Double time');
      }).join('; ') + '</div>';
    }

    // ========== BOTTOM 3-COLUMN SECTION ==========
    h += '<table style="width:100%"><tr>';

    // ----- LEFT: Equipment -----
    var eqRows = wo.equipment || [];
    var eqTotal = 0;
    eqRows.forEach(function(e) { eqTotal += (e.quantity || 0) * (e.unit_cost || 0); });
    var internalTotal = truckSubtotal + eqTotal;
    var basisAbbr = { day: 'day', week: 'wk', month: 'mo' };
    h += '<td style="width:30%;vertical-align:top;padding-right:2px">';
    h += '<table class="bdr" style="width:100%">';
    h += '<tr><td class="grey" style="width:16px">Qty</td><td class="grey l">Equipment</td><td class="grey" style="width:18px">Days</td><td class="grey" style="width:26px">Each</td><td class="grey" style="width:34px">Subtotal</td></tr>';
    var eqFillers = ['Service vehicle','Fuel Surcharge','407 ETR','Trailer','','Electric Welder','Diesel Welder','Propane Welder','110v TIG welder','Plasma Cutter','','Cutting Outfit','Roto Hammer','Hydraulic Rams','Track Jacks','Machine Skates','Corner Dollies','','Magdrill','Auto Level','Powervice'];
    eqFillers = eqFillers.slice(0, Math.max(1, eqFillers.length - eqRows.length));
    eqFillers.forEach(function(e, idx) {
      if (e === 'Service vehicle' && onSiteDays > 0 && truckDayUnits > 0) {
        h += '<tr><td class="c sm">' + truckQty + '</td><td class="sm">' + e + '</td><td class="c sm">' + onSiteDays + '</td><td class="sm r">$' + TRUCK_RATE.toFixed(2) + '</td><td class="sm r">$' + truckSubtotal.toFixed(2) + '</td></tr>';
      } else {
        h += '<tr><td class="c sm"></td><td class="sm">' + e + '</td><td class="sm"></td><td class="sm r"></td><td class="sm r"></td></tr>';
      }
      if (idx === 0) {
        // 365-owned equipment logged on this WO at the listed day / week / month rate
        eqRows.forEach(function(x) {
          var sub = (x.quantity || 0) * (x.unit_cost || 0);
          h += '<tr><td class="c sm">1</td><td class="sm">' + (x.item_name || '') + '</td><td class="c sm">' + (x.quantity || '') + ' ' + (basisAbbr[x.rate_basis] || '') + '</td><td class="sm r">$' + (x.unit_cost || 0).toFixed(2) + '</td><td class="sm r">$' + sub.toFixed(2) + '</td></tr>';
        });
      }
    });
    h += '<tr><td colspan="4" class="r b" style="font-size:9px">Internal Equipment $</td><td class="r b sm">' + (internalTotal > 0 ? '$' + internalTotal.toFixed(2) : '') + '</td></tr>';

    // Rental
    h += '<tr><td class="grey">Qty</td><td class="grey l">Rental Equipment</td><td class="grey"></td><td class="grey">Each</td><td class="grey">Subtotal</td></tr>';
    ['Forklift ___ ton','Forklift ___ ton','Broderson ___ ton','Articulating lift','Scissor lift'].forEach(function(r) {
      h += '<tr><td class="sm"></td><td class="sm">' + r + '</td><td class="sm"></td><td class="sm"></td><td class="sm"></td></tr>';
    });
    h += '<tr><td colspan="4" class="r b" style="font-size:9px">Rental Equipment $</td><td class="r b sm"></td></tr>';
    h += '</table></td>';

    // ----- MIDDLE: Consumables -----
    h += '<td style="width:34%;vertical-align:top;padding:0 2px">';
    h += '<table class="bdr" style="width:100%">';
    h += '<tr><td class="grey" style="width:16px">Qty</td><td class="grey l">Consumables</td><td class="grey" style="width:28px">Each</td><td class="grey" style="width:38px">Subtotal</td></tr>';
    var consTotal = 0;
    var matchedCons = [];
    var normCons = function(s) { return (s || '').toLowerCase().replace(/"/g, '').trim(); };
    var consAlias = {
      'oxygen (t cylinder)': ['oxygen'],
      'acetylene (small)': ['acetylene'],
      'argon (small, m-cyl)': ['argon (small)'],
      'argon (large, t-cyl)': ['argon (large)'],
      'diesel fuel (litres)': ['diesel fuel'],
      'gasoline (litres)': ['gasoline'],
      'shim (4x4)': ['shims (steel)'],
    };
    var consRow = function(label, match) {
      var qty = match ? match.quantity : '';
      var each = match && match.unit_cost ? match.unit_cost.toFixed(2) : '';
      var sub = match && match.quantity ? (match.quantity * (match.unit_cost || 0)).toFixed(2) : '';
      if (sub && parseFloat(sub) > 0) consTotal += parseFloat(sub);
      h += '<tr><td class="c sm">' + qty + '</td><td class="sm">' + label + '</td><td class="r sm">' + (each ? '$' + each : '') + '</td><td class="r sm">' + (sub && parseFloat(sub) > 0 ? '$' + sub : '') + '</td></tr>';
    };
    ['Propane (33lbs)','Oxygen (T Cylinder)','Acetylene (Small)','Argon (Small, M-Cyl)','Argon (Large, T-Cyl)','Nitrogen (T-Cyl)','','Diesel Fuel (Litres)','Gasoline (Litres)','','7018 x 1/8 (per lb)','7018 x 3/32 (per lb)','7018 x 5/32 (per lb)','309L - 1/8 (per lb)','3/32 316L Fillers','5" Zipcut Discs','6" Zipcut Discs','5" Grinding Discs','6" Grinding Discs','Sanding Discs','','Chemical Anchor','Deburr Bits','Shim (4x4)','','Anchors 3/8" x 4"','Anchors 1/2" x 5"','Anchors 5/8" x 6"'].forEach(function(c) {
      if (!c) { h += '<tr><td class="sm"></td><td class="sm"></td><td class="sm"></td><td class="sm"></td></tr>'; return; }
      var accepted = [normCons(c)].concat(consAlias[normCons(c)] || []);
      var match = wo.consumables.find(function(x) { return x.item_name && accepted.indexOf(normCons(x.item_name)) >= 0 && matchedCons.indexOf(x) < 0; });
      if (match) matchedCons.push(match);
      consRow(c, match);
    });
    wo.consumables.forEach(function(x) {
      if (matchedCons.indexOf(x) < 0 && x.item_name) consRow(x.item_name, x);
    });
    h += '<tr><td colspan="3" class="r b" style="font-size:9px">Consumables $</td><td class="r b sm">' + (consTotal > 0 ? '$' + consTotal.toFixed(2) : '') + '</td></tr>';
    h += '</table></td>';

    // ----- RIGHT: Purchases + Labour Summary + Totals -----
    h += '<td style="width:36%;vertical-align:top;padding-left:2px">';
    h += '<table class="bdr" style="width:100%">';
    h += '<tr><td class="grey" style="width:16px">Qty</td><td class="grey l">Purchases</td><td class="grey" style="width:42px">Subtotal</td></tr>';
    var purchTotal = 0;
    var purchRows = wo.purchases || [];
    purchRows.forEach(function(p) {
      var psub = (p.quantity || 0) * (p.unit_cost || 0);
      purchTotal += psub;
      h += '<tr><td class="c sm">' + (p.quantity || '') + '</td><td class="sm">' + (p.item_name || '') + '</td><td class="sm r">' + (psub > 0 ? '$' + psub.toFixed(2) : '') + '</td></tr>';
    });
    var purchFillers = ['Welding Stones','Hand Heat Shields','Cutting Lenses','Outside Lenses','TIG Ceramic Cups','P100 Organic Filters','Safety Glasses','Ear Muffs/Plugs','Clear Face Shields','Welding Gloves'];
    for (var pf = 0; pf < Math.max(0, purchFillers.length - purchRows.length); pf++) {
      h += '<tr><td class="sm"></td><td class="sm">' + purchFillers[pf] + '</td><td class="sm r"></td></tr>';
    }
    h += '<tr><td colspan="2" class="r b" style="font-size:9px">Purchases $</td><td class="r b sm">' + (purchTotal > 0 ? '$' + purchTotal.toFixed(2) : '') + '</td></tr>';
    h += '</table>';

    // Labour Rate Summary — MWF/MWFOT (foreman) + MW/MWOT (millwrights) + FAB/FABOT (shop fab, only when present)
    var amtCell = function(v) { return v > 0 ? '$' + v.toFixed(2) : ''; };
    var hrsCell = function(v) { return v > 0 ? fmtH(v) : ''; };
    h += '<table class="bdr" style="width:100%;margin-top:2px">';
    h += '<tr><td class="blue c" colspan="4">Labour</td></tr>';
    h += '<tr><td class="grey" style="width:46px">Code</td><td class="grey">Hrs</td><td class="grey">Rate</td><td class="grey" style="width:54px">Amount</td></tr>';
    rateLines.forEach(function(l) {
      if (!l.always && !(l.hours > 0)) return;
      h += '<tr><td class="c sm" style="white-space:nowrap" title="' + l.title + '">' + l.code + '</td><td class="c sm">' + hrsCell(l.hours) + '</td><td class="r sm">$' + l.rate.toFixed(2) + '</td><td class="r sm">' + amtCell(l.amount) + '</td></tr>';
    });
    h += '<tr><td class="c sm">Travel</td><td class="c sm">' + (travelHrs > 0 ? fmtH(travelHrs) : '') + '</td><td class="r sm sm">' + (travelHrs > 0 ? '$' + TRAVEL_RATE.toFixed(2) : '') + '</td><td class="r sm">' + (travelAmt > 0 ? '$' + travelAmt.toFixed(2) : '') + '</td></tr>';
    h += '<tr><td colspan="3" class="r b" style="font-size:9px">Total Labour $</td><td class="r b sm">$' + totalLabour.toFixed(2) + '</td></tr>';
    h += '</table>';

    // Cost Summary
    var grandTotal = totalLabour + consTotal + internalTotal + purchTotal;
    h += '<table style="width:100%;margin-top:2px;font-size:9px">';
    h += '<tr><td class="r" style="border:none">Internal Equipment</td><td class="r b" style="width:60px;border:1px solid #888">' + (internalTotal > 0 ? '$' + internalTotal.toFixed(2) : '$') + '</td></tr>';
    h += '<tr><td class="r" style="border:none">Rental Equipment</td><td class="r b" style="border:1px solid #888">$</td></tr>';
    h += '<tr><td class="r" style="border:none">Consumables</td><td class="r b" style="border:1px solid #888">' + (consTotal > 0 ? '$' + consTotal.toFixed(2) : '$') + '</td></tr>';
    h += '<tr><td class="r" style="border:none">Purchases</td><td class="r b" style="border:1px solid #888">' + (purchTotal > 0 ? '$' + purchTotal.toFixed(2) : '$') + '</td></tr>';
    h += '<tr><td class="r" style="border:none">Labour</td><td class="r b" style="border:1px solid #888">$' + totalLabour.toFixed(2) + '</td></tr>';
    h += '<tr><td class="r b" style="border:none;font-size:11px;padding-top:4px">Grand Total (tax out) $</td>';
    h += '<td style="font-size:13px;font-weight:bold;text-align:right;border:2px solid #000;padding:4px 5px">$' + grandTotal.toFixed(2) + '</td></tr>';
    h += '</table>';

    h += '</td></tr></table>';

    // ========== SIGNATURES ==========
    h += '<table style="width:100%;margin-top:6px;font-size:10px"><tr>';
    h += '<td><b>Customer P.O.#:</b> <span class="sig" style="min-width:100px"></span></td>';
    h += '<td></td></tr>';
    h += '<tr style="height:10px"><td></td><td></td></tr>';
    h += '<tr><td><b>Customer Approval:</b> ' + (sigHtml || '<span class="sig"></span>') + '</td>';
    h += '<td class="r"><b>Service Technician:</b> <span class="sig"></span></td></tr>';
    h += '</table>';

    h += '</div>';
    h += '</body></html>';
    pw.document.write(h);
  });
  pw.document.close();
  // Let the letterhead (and signature) finish loading before the dialog opens — otherwise the
  // preview shows a blank header and you have to close/reopen it. Capped so a slow image can't hang it.
  var imgs = pw.document ? Array.prototype.slice.call(pw.document.images || []) : [];
  var pending = imgs.filter(function (im) { return !im.complete; });
  var done = false;
  var go = function () {
    if (done) return; done = true;
    fitPagesToOneSheet(pw);
    pw.print();
  };
  if (!pending.length) { go(); return; }
  var left = pending.length;
  pending.forEach(function (im) {
    im.addEventListener('load', function () { if (--left <= 0) go(); });
    im.addEventListener('error', function () { if (--left <= 0) go(); });
  });
  setTimeout(go, 2500);
}

// Same timesheet, but as one HTML string (for "Send to office printer" → server-side PDF) instead of a print window.
export function timesheetHtml(data, dateFrom, dateTo, signatureDataUrl, numbersByWo) {
  var docs = [];
  var fake = { document: { write: function (s) { docs.push(s); }, close: function () {}, querySelectorAll: function () { return []; } }, print: function () {} };
  printTimesheet(data, dateFrom, dateTo, signatureDataUrl, numbersByWo, fake);
  if (!docs.length) return '';
  var head = docs[0].split('<body>')[0];
  var bodies = docs.map(function (d) { var m = d.split('<body>')[1] || ''; return m.replace(/<\/body><\/html>\s*$/, ''); });
  return head + '<body>' + bodies.join('') + '</body></html>';
}

// Letter page (11in) minus @page margins (0.4cm ×2) and body padding (12px ×2) ≈ 1000px of printable
// height. Anything taller (long service notes, 9+ crew, wrapped text) is zoomed down (with ~25px of
// slack for print rounding) so each work order still prints on ONE sheet instead of spilling its
// signature block onto a second page.
var PRINTABLE_H = 990, FIT_TARGET_H = 975;
function fitPagesToOneSheet(pw) {
  try {
    var pages = pw.document.querySelectorAll('.ts-page');
    for (var i = 0; i < pages.length; i++) {
      var el = pages[i];
      var hgt = el.getBoundingClientRect().height;
      if (hgt > PRINTABLE_H) el.style.zoom = String(Math.max(0.6, Math.floor((FIT_TARGET_H / hgt) * 100) / 100));
    }
  } catch (e) { /* best effort */ }
}

// "Service covered by this Timesheet": the PM's saved text for the WO/week, else the crew's daily notes.
export const fmtNoteDay = (d) => new Date(`${d}T12:00:00`).toLocaleDateString('en-US', { weekday: 'short', month: 'numeric', day: 'numeric' });
export const crewNotesText = (wo) => (wo.crew_notes || []).map(n => `${fmtNoteDay(n.date)} — ${n.employee_name}: ${n.notes}`).join('\n');
export const serviceText = (wo) => (wo.service_description || '').trim() || crewNotesText(wo);
export const escHtml = (t) => String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
